















































































import { Component, Vue, Prop, Emit, Watch } from 'vue-property-decorator'

/**
 * Filtros avançados do Recebimento Monitor. Status e Usuário moram aqui; Tipo e o período
 * ficam na tela, porque o período é a leitura padrão da listagem (3 dias) e esconder isso
 * faria a pessoa achar que a tela perdeu registros (FXSR-3152).
 *
 * Os valores só sobem para a tela quando a pessoa clica em Filtrar — o que está digitado
 * aqui é rascunho até lá.
 */
@Component
export default class ComponentRecebimentoMonitorRightNavBar extends Vue {
  @Prop({ default: false }) visible: boolean
  @Prop({ default: '' }) status: string
  @Prop({ default: '' }) nomeUsuario: string
  @Prop({ default: () => [] }) statusList: any[]
  @Prop({ default: 0 }) totalResultados: number
  @Prop({ default: false }) carregando: boolean

  statusLocal: string = ''
  nomeUsuarioLocal: string = ''

  get drawer() {
    return this.visible
  }

  set drawer(value: boolean) {
    if (!value) {
      this.close()
    }
  }

  @Emit('close')
  close() {}

  @Emit('filtrar')
  filtrar() {
    return {
      statusEnum: this.statusLocal || '',
      nomeUsuario: this.nomeUsuarioLocal || '',
    }
  }

  @Emit('limpar')
  limpar() {
    this.statusLocal = ''
    this.nomeUsuarioLocal = ''
  }

  /** Ao abrir, o rascunho parte do que está aplicado na tela. */
  @Watch('visible')
  onVisibleChange(aberto: boolean) {
    if (!aberto) {
      return
    }

    this.statusLocal = this.status || ''
    this.nomeUsuarioLocal = this.nomeUsuario || ''
  }
}
